export default __webpack_public_path__ + "static/media/orden-trabajo-manual.36117305.svg";